export const REQUEST_STATUSES = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

export const DELAY_FOR_AUTOCOMPLETE = 600;

export const NONE_TEXT = 'None';
